import React from 'react';
import { useNavigate } from 'react-router-dom';

function Features() {
  const navigate = useNavigate();

  const goToFeatures = () => navigate('/school-management/all-features');

  return (
    <section className="section features-section" id="features">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Powerful Features Built for Schools</h2>
          <p className="section-desc">Everything you need to manage academics and administration effortlessly.</p>
        </div>

        <div className="features-grid">
          <div className="feature-card" onClick={goToFeatures} style={{ cursor: 'pointer' }}>
            <div className="feature-icon">
              <i className="fas fa-user-plus"></i>
            </div>
            <h3 className="feature-title">Student Admission & Profiles</h3>
            <p className="feature-desc">Streamline admissions with digital forms, document management, and comprehensive student profiles.</p>
          </div>

          <div className="feature-card" onClick={goToFeatures} style={{ cursor: 'pointer' }}>
            <div className="feature-icon">
              <i className="fas fa-clipboard-check"></i>
            </div>
            <h3 className="feature-title">Attendance Management</h3>
            <p className="feature-desc">Track attendance in real-time with biometric integration, automated reports, and parent notifications.</p>
          </div>

          <div className="feature-card" onClick={goToFeatures} style={{ cursor: 'pointer' }}>
            <div className="feature-icon">
              <i className="fas fa-credit-card"></i>
            </div>
            <h3 className="feature-title">Fees & Online Payments</h3>
            <p className="feature-desc">Manage fee collection with automated reminders, online payment gateway, and instant receipt generation.</p>
          </div>

          <div className="feature-card" onClick={goToFeatures} style={{ cursor: 'pointer' }}>
            <div className="feature-icon">
              <i className="fas fa-file-alt"></i>
            </div>
            <h3 className="feature-title">Exams + Gradebook</h3>
            <p className="feature-desc">Create exams, manage grades, generate mark sheets, and publish results instantly to students and parents.</p>
          </div>

          <div className="feature-card" onClick={goToFeatures} style={{ cursor: 'pointer' }}>
            <div className="feature-icon">
              <i className="fas fa-comments"></i>
            </div>
            <h3 className="feature-title">Parent/Teacher Communication</h3>
            <p className="feature-desc">Enable seamless communication through messaging, announcements, and real-time notifications.</p>
          </div>

          <div className="feature-card" onClick={goToFeatures} style={{ cursor: 'pointer' }}>
            <div className="feature-icon">
              <i className="fas fa-chart-bar"></i>
            </div>
            <h3 className="feature-title">Reports & Analytics</h3>
            <p className="feature-desc">Generate comprehensive reports with data-driven insights for informed decision making.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
